import { gql } from '@apollo/client';

export const CREATE_APP_RATING_MUTATION = gql`
  mutation CreateAppRating($data: AppRatingInput!) {
    createAppRating(input: { data: $data }) {
      appRating {
        id
      }
    }
  }
`;
